import { cva } from 'class-variance-authority';

type TypographyVariant =
  | 'title-xxsmall'
  | 'title-xsmall'
  | 'title-small'
  | 'title-medium'
  | 'title-large'
  | 'title-xlarge'
  | 'body-xsmall'
  | 'body-small'
  | 'body-medium'
  | 'body-large'
  | 'caption';
type TypographyWeight = 'regular' | 'medium' | 'bold' | 'extrabold' | 'black';

export const typographyVariantOptions: TypographyVariant[] = [
  'title-xxsmall',
  'title-xsmall',
  'title-small',
  'title-medium',
  'title-large',
  'title-xlarge',
  'body-xsmall',
  'body-small',
  'body-medium',
  'body-large',
  'caption',
];

export const typographyWeightOptions: TypographyWeight[] = [
  'regular',
  'medium',
  'bold',
  'extrabold',
  'black',
];

type TypographyConfig = {
  variants: {
    variant: Record<TypographyVariant, string>;
    weight: Record<TypographyWeight, string>;
  };
  defaultVariants: { variant: TypographyVariant; weight: TypographyWeight };
};

const typographyConfig: TypographyConfig = {
  variants: {
    variant: {
      'title-xxsmall': 'text-xl leading-tight', // 20px
      'title-xsmall': 'text-2xl leading-tight', // 24px
      'title-small': 'text-3xl leading-tight', // 30px
      'title-medium': 'text-4xl leading-tight', // 36px
      'title-large': 'text-5xl leading-snug', // 48px
      'title-xlarge': 'text-6xl leading-snug', // 60px

      'body-xsmall': 'text-xs leading-tight',
      'body-small': 'text-sm leading-normal', // 14px
      'body-medium': 'text-base leading-normal', // 16px
      'body-large': 'text-lg leading-relaxed', // 18px

      caption: 'text-xs leading-tight uppercase tracking-wide', // 12px
    },
    weight: {
      regular: 'font-normal',
      medium: 'font-medium',
      bold: 'font-bold',
      extrabold: 'font-extrabold',
      black: 'font-black',
    },
  },
  defaultVariants: { variant: 'body-medium', weight: 'regular' },
};

export const typographyVariants = cva('text-foreground', typographyConfig);
